import { render } from "./Step6.vue?vue&type=template&id=02fc2e54&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"

import "./Step6.vue?vue&type=style&index=0&id=02fc2e54&lang=css&scoped=true"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fc2e54"]])

export default __exports__